import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import keymaster from 'keymaster';
import moment from 'moment';
import roles from '../utils/roles';

import Spinner from './Spinner';
import WeekItem from './WeekItem';

import timesheetActions from '../actions/timesheetActionCreators';

class TimesheetOverview extends React.Component {
    
    constructor(props, context) {
        super(props, context);

        this.state = {
            currentYear: parseInt(moment().format("YYYY")),
            currentPart: parseInt(moment().format("Q"))
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.currentUser) {
            //way to transition to root using react-router if user has no roles
            if(!roles.userHasAnyOfRoles(nextProps.currentUser, ['PMO'])) {
                browserHistory.push('/');
            }
        }
    }

    componentDidMount = () => {
        moment.updateLocale('en', {
            week: { doy: 4, dow: 1 }
        });

        //this.props.dispatch(timesheetActions.pmoLoadByYear(moment().format("YYYY")));

        this.props.dispatch(timesheetActions.pmoLoadByRange(moment().format("YYYY"), moment().format("Q")));

        keymaster('left', this.decrementTime);
        keymaster('right', this.incrementTime);
    }

    componentWillUnmount = () => {
        keymaster.unbind('left');
        keymaster.unbind('right');
    }

    // OTHER METHODS

    decrementTime = () => {
        let newYear = this.state.currentPart === 1 ? this.state.currentYear - 1 : this.state.currentYear;
        let newPart = this.state.currentPart === 1 ? 4 : this.state.currentPart - 1;

        this.setState({
            currentYear: newYear,
            currentPart: newPart
        }, this.loadTimesheets);
    }

    incrementTime = () => {
        let newYear = this.state.currentPart === 4 ? this.state.currentYear + 1 : this.state.currentYear;
        let newPart = this.state.currentPart === 4 ? 1 : this.state.currentPart + 1;

        this.setState({
            currentYear: newYear,
            currentPart: newPart
        }, this.loadTimesheets);
    }

    loadTimesheets = () => {
        // this.props.dispatch(timesheetActions.pmoLoadByYear(this.state.currentYear));
        this.props.dispatch(timesheetActions.pmoLoadByRange(this.state.currentYear, this.state.currentPart));
    }

    // RENDER METHOD

    render = () => {
        let weeks = Object.keys(this.props.timesheetMap);
        weeks.sort();
        weeks.reverse();

        if (weeks.length == 0) {
            return (
                <div>
                    <div className="text-center">
                        <div className="week-header">
                            <div className="panel-log-date">
                                {
                                    this.props.loading
                                        ? null
                                        : <i onClick={this.decrementTime} className="md-chevron-left md-lg"></i>
                                }
                                <h4><span><span style={{ display: "inline-block" }}>{this.state.currentYear} (Q{this.state.currentPart})</span></span></h4>
                                {
                                    this.props.loading
                                        ? null
                                        : <i onClick={this.incrementTime} className="md-chevron-right md-lg"></i>
                                }
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div className="text-center">
                    {
                        this.props.loading ?
                        <Spinner />
                        :
                        <h4> There are no timesheets to show </h4>
                    }
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="text-center">
                        <div className="week-header">
                            <div className="panel-log-date">
                                {
                                    this.props.loading
                                        ? null
                                        : <i onClick={this.decrementTime} className="md-chevron-left md-lg"></i>
                                }
                                <h4><span><span style={{ display: "inline-block" }}>{this.state.currentYear} (Q{this.state.currentPart})</span></span></h4>
                                {
                                    this.props.loading
                                        ? null
                                        : <i onClick={this.incrementTime} className="md-chevron-right md-lg"></i>
                                }
                            </div>
                        </div>
                    </div>
                    <br/>
                    <table className="table table-condensed project-people">
                        <thead>
                            <tr>
                                <th>Week</th>
                                <th className="text-center">Not ready for submit</th>
                                <th className="text-center">Ready for submit</th>
                                <th className="text-center">With rejected records</th>
                                <th className="text-center">Submitted</th>
                                <th className="text-center">Approved</th>
                                <th className="text-center">Total</th>
                            </tr>
                        </thead>
                        <tfoot>
                            <tr/>
                        </tfoot>
                        <tbody>
                            {
                                weeks.map((week, key) => {
                                    let timesheets = this.props.timesheetMap[week];
                                    return <WeekItem handleReload={this.loadTimesheets} key={key} timesheets={timesheets}/>;
                                })
                            }
                        </tbody>
                    </table>
                </div>
            );
        }
    }
}

TimesheetOverview.contextTypes = {
    router: PropTypes.object.isRequired
};

TimesheetOverview.propTypes = {
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    loading: PropTypes.bool,
    timesheetMap: PropTypes.array
};

const mapStateToProps = (state) => {
    let timesheets = state.timesheets.timesheets;
    let timesheetMap = [];
        for (let i = 0; i < timesheets.length; i++) {
            let timesheet = timesheets[i];
            if (!timesheetMap[timesheet.week]) {
                timesheetMap[timesheet.week] = {
                    week: timesheet.week,
                    startDate: timesheet.startDate,
                    endDate: timesheet.endDate,
                    empty: [],
                    readyToSubmit: [],
                    withRejectedRecords: [],
                    submitted: [],
                    approved: [],
                    all: []
                };
            }
            if (timesheet.status === "APPROVED") {
                timesheetMap[timesheet.week].approved.push(timesheet);
            } else if (timesheet.status === "FIXING") {
                timesheetMap[timesheet.week].withRejectedRecords.push(timesheet);
            } else if (timesheet.status === "SUBMITTED") {
                timesheetMap[timesheet.week].submitted.push(timesheet);
            } else if (timesheet.status === "ENTRY") {
                if (timesheet.submittable) {
                    timesheetMap[timesheet.week].readyToSubmit.push(timesheet);
                } else {
                    timesheetMap[timesheet.week].empty.push(timesheet);
                }
            }
            timesheetMap[timesheet.week].all.push(timesheet);
        }

    return {
        currentUser: state.users.currentUser,
        loading: state.timesheets.loading,
        timesheetMap: timesheetMap
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TimesheetOverview);



/** WEBPACK FOOTER **
 ** ./src/app/components/TimesheetOverview.js
 **/